import { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import { selectIsFavourite } from './selectors'
import { toggleFavourite } from './actions'
import { getCustomer } from 'helpers'

const Button = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  padding: 0;
  margin: 0 5px;

  &:focus {
    outline: none;
  }

  .fa-star-o {
    color: var(--dark-gray);
  }

  .fa-star {
    color: #ffb600;
  }
`

class FavouritesToggle extends Component {
  handleClick = () => {
    const { contentType, contentId, deviceId, toggleFavourite, contentTitle } =
      this.props
    toggleFavourite({
      contentType,
      contentId,
      deviceId,
      contentTitle,
      customer: getCustomer()
    })
  }

  render() {
    const { isFavourite } = this.props

    const tooltip = <Tooltip id="tooltip">Toggle article favorite</Tooltip>
    return (
      <span>
        <OverlayTrigger placement="top" overlay={tooltip}>
          <Button onClick={this.handleClick}>
            <FontAwesome name={isFavourite ? 'star' : 'star-o'} />
          </Button>
        </OverlayTrigger>
      </span>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFavourite: selectIsFavourite(state, ownProps)
})

const mapDispatchToProps = (dispatch) => ({
  toggleFavourite: (favourite) => dispatch(toggleFavourite(favourite))
})

export default connect(mapStateToProps, mapDispatchToProps)(FavouritesToggle)
